import { render, staticRenderFns } from "./SLD.vue?vue&type=template&id=a2b8c05c"
import script from "./SLD.vue?vue&type=script&lang=js"
export * from "./SLD.vue?vue&type=script&lang=js"
import style0 from "./SLD.vue?vue&type=style&index=0&id=a2b8c05c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports